import { openDB } from "idb";

export const dbPromise = openDB("jukai-cloud", 4, {
    upgrade(db, oldVersion) {
        if (!db.objectStoreNames.contains("queue")) {
            db.createObjectStore("queue", {
                keyPath: "id",
                autoIncrement: true
            })
        }

        if (!db.objectStoreNames.contains("logs")) {
            db.createObjectStore("logs", {
                keyPath: "id",
                autoIncrement: true
            })
        }

        if (!db.objectStoreNames.contains("attendance_status")) {
            db.createObjectStore("attendance_status", {keyPath: "key"})
        }

        if (!db.objectStoreNames.contains("teams_cache")) {
            db.createObjectStore("teams_cache", { keyPath: "key" })
        }
    }
})